import CurrencyIcon, { TetherIconColorOptions } from '@/components/CurrencySymbolMask/CurrencyIcon';
import { formatCurrency } from '@/pages/table/utils/utils';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface TablePotInfoProps {
  fontSize?: string;
  color?: string;
  averagePot?: number;
}

const TablePotInfo: FC<TablePotInfoProps> = ({
  fontSize = '',
  averagePot = 0,
  color = TetherIconColorOptions.green,
}) => {
  return (
    <span className={twMerge('flex flex-row items-center', fontSize)}>
      <CurrencyIcon fill={color} />
      {formatCurrency(averagePot, { shortFormat: true })}
    </span>
  );
};

export default TablePotInfo;
